import { render, staticRenderFns } from "./Inventorymanagement.vue?vue&type=template&id=c87bec02&"
import script from "./Inventorymanagement.vue?vue&type=script&lang=js&"
export * from "./Inventorymanagement.vue?vue&type=script&lang=js&"
import style0 from "./Inventorymanagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports